import React from "react";
import { string, number, array, func, bool } from "prop-types";
import { LoadMoreCollectionStories } from "@quintype/components";

import Stories2AdWithLoadMore from "../Stories2AdWithLoadMore";
import DfpAd from "../../dfp-ad";

const NO_OF_STORIES_TO_LOAD = 20;

const SixteenStories3AdWithTagSearchAndLoadMore = ({ collectionSlug, stories, widgetUrl, widgetHeight, lang }) => {
  const list = stories.map((story) => story);
  const storiesSet = list.map(({ story }) => story).slice(0, 20);

  if (list.length < 0) {
    return null;
  }

  return (
    <div>
      <DfpAd
        adType={lang === "en" ? "EnPalo_ROS_468x60_B1" : "News_468x60_B1"}
        slotId="SixteenStories3AdWithTagSearchAndLoadMore"
      />
      {stories.length > 0 && (
        <LoadMoreCollectionStories
          collectionSlug={collectionSlug}
          template={MoreCollectionStories}
          data={{ stories: storiesSet }}
          numStoriesToLoad={NO_OF_STORIES_TO_LOAD}
        />
      )}
    </div>
  );
};

const MoreCollectionStories = ({ stories, onLoadMore, loading, noMoreStories }) => (
  <Stories2AdWithLoadMore
    list={stories}
    loading={loading}
    onLoadMore={onLoadMore}
    isMoreStories={NO_OF_STORIES_TO_LOAD < stories.length && !noMoreStories}
    className="loadmore-stories"
  />
);

SixteenStories3AdWithTagSearchAndLoadMore.propTypes = {
  accentColor: string,
  numberOfCardsInViewDesktop: number,
  numberOfCardsInViewTablet: number,
  numberOfCardsInViewMobile: number,
  stories: array,
  collectionSlug: string,
  widgetUrl: string,
  widgetHeight: string,
  lang: string,
};

MoreCollectionStories.propTypes = {
  stories: array.isRequired,
  onLoadMore: func,
  noMoreStories: number,
  loading: bool,
};

export default SixteenStories3AdWithTagSearchAndLoadMore;
